import React from "react"

/** Two overlapping documents — the Global Files sidebar entry. */
export function Files(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 0.5C1.67157 0.5 1 1.17157 1 2V12C1 12.8284 1.67157 13.5 2.5 13.5H10.5C11.3284 13.5 12 12.8284 12 12V4.62132C12 4.35611 11.8946 4.10175 11.7071 3.91421L8.58579 0.792893C8.39825 0.605357 8.14389 0.5 7.87868 0.5H2.5Z"
        fill="currentColor"
        opacity="0.5"
      />
      <path
        d="M3.75 3C2.7835 3 2 3.7835 2 4.75V14.25C2 15.2165 2.7835 16 3.75 16H10.75C11.7165 16 12.5 15.2165 12.5 14.25V6.75H9.75C9.19772 6.75 8.75 6.30228 8.75 5.75V3H3.75ZM9.75 3V5.75H12.5L9.75 3Z"
        fill="currentColor"
      />
    </svg>
  )
}
